import(/* webpackMode: "eager", webpackExports: ["CategoryCard"] */ "/vercel/path0/app/ui/parts/default/sp/parts/categoryCard.tsx");
